export default __webpack_public_path__ + "static/media/exampleAlumnes.ed0dd864.csv";